import { Form } from 'antd';
import styled from 'styled-components';
import { Drawer } from 'ui';
import { CouponFormValues } from './CouponCreateUpdateDrawer';

export const StyledForm = styled(Form<CouponFormValues>)`
  .description {
    font-size: 14px;
    color: ${(props) => props.theme.descriptionText};
    margin: -20px 0 20px 0;
  }

  .label {
    font-size: 14px;
    color: ${(props) => props.theme.colorPrimary};
  }

  .ant-picker-range {
    width: 100%;
  }

  .discount-select .ant-form-item {
    margin-bottom: 0;
  }

  .discount-select .ant-space-compact > .ant-form-item {
    width: 60%;
  }

  .discount-select .ant-space-compact > .ant-form-item:nth-child(2) {
    width: 40%;
  }

  .discount-select .ant-space-compact {
    width: 100%;
  }

  .discount-select .ant-select {
    width: 100%;
  }

  .discount-select .ant-select-selector {
    background: ${(props) => props.theme.inputAddonBg};
  }
`;

export const StyledCouponCreateUpdateDrawer = styled(Drawer)`
  .ant-drawer-header-title {
    flex-direction: row-reverse;
    .ant-drawer-close {
      margin-inline-end: 0;
      color: ${(props) => props.theme.black};
    }
  }
  .ant-drawer-footer {
    .footer {
      display: flex;
      align-items: center;
      gap: 20px;
      justify-content: flex-end;
    }
  }
`;
